import {Component, input} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {TranslationKey} from "@models";
import {TranslateModule} from "@ngx-translate/core";

@Component({
	selector: "sim-labelled-container",
	standalone: true,
	imports: [MatIcon, TranslateModule],
	templateUrl: "./labelled-container.component.html",
	styleUrl: "./labelled-container.component.scss",
})
export class LabelledContainerComponent {
	public readonly icon = input.required<string>();
	public readonly label = input.required<TranslationKey | string>();
}
